// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d0ff4839","885":"b4b889a4"}[chunkId] + ".chunk.js";
};